module.exports = __webpack_public_path__ + "static/media/HCMM433.205fd5ff.jpg";